import { render, staticRenderFns } from "./reinforce_type.vue?vue&type=template&id=0f9ad1c5&scoped=true"
import script from "./reinforce_type.vue?vue&type=script&lang=js"
export * from "./reinforce_type.vue?vue&type=script&lang=js"
import style0 from "./reinforce_type.vue?vue&type=style&index=0&id=0f9ad1c5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f9ad1c5",
  null
  
)

export default component.exports